import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { SubscriptionsManager } from 'src/app/shared/helpers/subscriptions-manager';
import { selectCurrentUser } from 'src/app/shared/stores/selectors/user.selectors';
import { AppState, AppUserState } from 'src/app/shared/stores/states/app.state';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  isDropdownOpen = false;
  currentUser!: AppUserState;
  currentTheme: string = '';
  environment = environment;
  userMenuOpen = false;
  version = environment.version;

  private subsManager = new SubscriptionsManager();
  constructor(
    private store: Store<AppState>,
    private themeService: ThemeService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private ngxCookieService: CookieService) {

    this.currentTheme = this.themeService.getCurrentThemeName();

    this.subsManager.add(
      this.themeService.themeChanged$.subscribe(() => {
        this.currentTheme = this.themeService.getCurrentThemeName();
        this.cdr.detectChanges();
      })
    );

  }
  ngOnInit(): void {
    this.subsManager.add(
      this.store
        .pipe(select(selectCurrentUser))
        .subscribe((currentUser: AppUserState) => {
          if (currentUser) {
            this.currentUser = currentUser;
          }
        }),
    );
  }
  ngOnDestroy(): void {
    this.subsManager.unsubscribeAll();
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  logout() {

    localStorage.clear();
    sessionStorage.clear();
    this.ngxCookieService.delete('uam-id-token', "/", environment.cookieInfo.domain);
    this.ngxCookieService.delete('uam-refresh-token', "/", environment.cookieInfo.domain);
    this.ngxCookieService.delete('uam-device-key', "/", environment.cookieInfo.domain);
    document.location.href = environment.uamUrl + 'auth/logout';

  }
  getUserInitials(): string {
    if (!this.currentUser?.name) return '';

    const firstName = this.currentUser.name.charAt(0);
    const lastName = this.currentUser.family_name
      ? this.currentUser.family_name.charAt(0)
      : '';

    return (firstName + lastName).toUpperCase();
  }
  goHome() {
    this.router.navigateByUrl('/');
  }
  goToApplicationsLauncher() {
    window.location.href = environment.uamUrl;
  }
  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
  }

}
